import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/app/[locale]/reviews/reviews.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df0f255e036290/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerReviewCard"] */ "/tmp/8df0f255e036290/components/sections/CustomerReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuestReviewCard"] */ "/tmp/8df0f255e036290/components/sections/GuestReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerReviewsGrid"] */ "/tmp/8df0f255e036290/components/sections/PartnerReviewsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSection"] */ "/tmp/8df0f255e036290/components/sections/ReviewSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8df0f255e036290/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Container.module.css");
